import { request } from '../request'
import { Writer } from '../types'
import { Injectable } from "@angular/core"

@Injectable()
export class WritersService {

  getWriter(id: number, options?: Object): Promise<Writer> {
    return request.get(`/api/writers/${id}.json`, options)
  }

  getWriterBySlug(slug: string, options?: Object): Promise<Writer> {
    return request.get(`/api/writers/slug/${slug}.json`, options)
  }

  getWriters(ids: number[]): Promise<Writer[]> {
    return request.get(`/api/writers.json`, { ids: ids.join(',') })
  }

  reactivateAccount(id: number): Promise<any> {
    return request.put(`/api/writers/${id}/reactivate`)
  }
}
